import React from "react";
// import styled from "styled-components";
import Partners from "./partners";
// import ContactForm from "./ContactForm";
import Footer from "./Footer";

// const HeaderGif = styled.img`
// width:auto;
// height:auto;
// max-width:100%;
// max-height:100%;
// `;

import animatedBg from "./assets/kajdom.gif";

const App = () => (
  <div>
    {/* <HeaderGif src="./kajdom.gif" alt="Landing Page GIF" />; */}
    <div className="headbg" style={{ backgroundImage: `url(${animatedBg})` }} />
    <Partners />
    {/* <ContactForm /> */}
    <Footer />
  </div>
);

export default App;
